import store from '@/store/index.js'
import { vue_instance } from '@/main.js'

function isJSON(jsonString) {
    try {
        var o = JSON.parse(jsonString);
  
        // Handle non-exception-throwing cases:
        // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
        // but... JSON.parse(null) returns null, and typeof null === "object", 
        // so we must check for that, too. Thankfully, null is falsey, so this suffices:
        if (o && typeof o === "object") {
            return true
        }
    }
    catch (e) {
        return false
     }
    return false
}

function JSONParse(jsonString) {
    if(isJSON(jsonString)) return JSON.parse(jsonString)
    else return {}
}

function ArrayParse(jsonString) {
    if(isJSON(jsonString)) return JSON.parse(jsonString)
    else return []
}

function stringToArray(string){
    let new_array = []

    if(typeof(string)=='string') 
        { new_array = string.split(',')
          for(let i=0; i<new_array.length; i++)
          {
              new_array[i] = new_array[i].replace(/^\s+|\s+$/g,"")
          }
          return new_array
        }
    else return false

}

function arrayToString(array){
    if(Array.isArray(array)) {
        return array.toString(array)
    }
    else return false
}

function deepCopy(obj) {
    if (obj === null || typeof(obj) !== 'object')
    return obj;
  
    var copy = obj.constructor();
  
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) {
        copy[attr] = deepCopy(obj[attr])
      }
    }
  
    return copy
}

function stringToDate(string) {
    //"2019-11-13" 형식의 데이터를 Javascript Date로 변환하여 반환

    let new_date = new Date(string)
    new_date.setHours(0)
    new_date.setMinutes(0)
    new_date.setSeconds(0)
    
    return new_date 
}

function dateToString(date) {
    //날짜를 "2019-11-13"로 변환하여 반환
    
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

function getTimeStamp() {

    let d = new Date();

    let s =
        leadingZeros(d.getFullYear(), 4) + '-' +
        leadingZeros(d.getMonth() + 1, 2) + '-' +
        leadingZeros(d.getDate(), 2);

    return s;
}

function leadingZeros(n, digits) {

    var zero = '';
    n = n.toString();

    if (n.length < digits) {
        for (let i = 0; i < digits - n.length; i++)
            zero += '0';
    }

    return zero + n;
}

function getImage(path, thumb){
    let dirname_re = /.+[/\\]/g
    let filename_re = /[/\\][^/\\]*$/g
    let filename = filename_re.exec(path)
    filename = filename.toString().replace(/[/\\]/, '')
    let dirname = dirname_re.exec(path)

    let static_host = store.state.static_host

    if(thumb==true) { filename = 'thumb_' + filename }
    return static_host + dirname + filename
}

function getFile(filename, filepath, thumb){
    const path = store.state.backend_host + '/get_file'

    let params = {
        filename: filename, 
        filepath: filepath, 
    }

    if (thumb == true){
        params.thumb = true
    }

    return axios.get(path, { params: params , responseType: 'blob' })
    .then( response => {
        let file_data = {}
        if ( (navigator.appName == 'Netscape' && navigator.userAgent.toLowerCase().indexOf('trident') != -1) || (navigator.userAgent.toLowerCase().indexOf("msie") != -1) ||
            navigator.appVersion.indexOf('Edge') > -1 ) {
            // ie 또는 edge일 경우 경우
            file_data = response.data
            file_data.name = filename
        }
        else {
            file_data = new File([response.data], filename)
        }
        // console.log(response)
        let new_file = {}
        new_file.link = URL.createObjectURL(file_data)
        new_file.filename = response.data.filename

        return new_file                     
    })
}

function getFileAsData(filename, filepath, thumb){
    const path = store.state.backend_host + '/get_file'

    let params = {
        filename: filename, 
        filepath: filepath, 
    }
    if (thumb == true){
        params.thumb = true
    }

    return axios.get(path, { params: params , responseType: 'blob' })
    .then( response => {
        let file_data = {}
        if ( (navigator.appName == 'Netscape' && navigator.userAgent.toLowerCase().indexOf('trident') != -1) || (navigator.userAgent.toLowerCase().indexOf("msie") != -1) ||
            navigator.appVersion.indexOf('Edge') > -1 ) {
            // ie 또는 edge일 경우 경우
            file_data = response.data
            file_data.name = filename
        }
        else {
            file_data = new File([response.data], filename)
        }

        return file_data                     
    })
}

function anchorGo(anchor){
    // console.log(anchor);
    if(anchor && document.querySelector(anchor)) {
        let elem = document.querySelector(anchor);
        let elemTop = window.pageYOffset + elem.getBoundingClientRect().top;   
        // console.log(elemTop)
        setTimeout(function () {
            window.scrollTo(0, elemTop-50)
        }, 0.01)
    }
}


export { isJSON, JSONParse, ArrayParse, stringToArray, arrayToString, deepCopy, stringToDate, dateToString, getTimeStamp, getFile, getImage, getFileAsData, anchorGo}